import React from "react";
import {
  Box,
  Spinner
} from "@chakra-ui/react";
import {
  Redirect,
  Route,
  RouteProps
} from "react-router-dom";

import { useAuthContext } from "src/hooks/useAuthContext";

export const PrivateRoute: React.FC<RouteProps> = ({
  location,
  component,
  ...props
}) => {
  const { authDataState } = useAuthContext();

  if (!authDataState.authenticated) {
    return (
      <Route
        location={location}
        {...props}
      >
        {(authDataState.authenticating || authDataState.fetchingUser) ? (
          <Box
            h="100%"
            w="100%"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Spinner size="lg" />
          </Box>
        ) : (
          <Redirect
            to={{
              pathname: "/login",
              state: { from: location?.pathname }
            }}
          />
        )}
      </Route>
    );
  }

  return (
    <Route
      location={location}
      component={component}
      {...props}
    />
  );
};